export const portfolios = (state) => state?.entities?.portfolio;
export const portfoliosList = (state) =>
  portfolios(state) ? Object.values(portfolios(state)) : [];
export const portfolio = (state, id) => portfolios(state)?.[id];
